import { Icon } from '@material-ui/core';
import MyCollapse from 'components/Collapse';
import Spin from 'components/Spin';
import React, { useState, useCallback } from 'react';
import { toast } from 'react-toastify';
import shoppingService from 'v2/services/shopping/product';

import type { IFiscalDocuments, ShoppingDelivery } from 'v2/interfaces/shopping';

import useStyle from '../styles';

const FiscalDocument = ({ delivery }: { delivery: ShoppingDelivery }) => {
  const classes = useStyle();
  const [loadingDocuments, setLoadingDocument] = useState<boolean>(false);
  const [fiscalDocuments, setFiscalDocuments] = useState<any[]>([]);

  const handleClickFiscalDocuments = useCallback(async (invoiceId: string) => {
    setLoadingDocument(true);
    shoppingService.loadFiscalDocuments(invoiceId).subscribe((res) => {
      setFiscalDocuments(res.data);
      setLoadingDocument(false);
    }, toast.error);
  }, []);

  return (
    <MyCollapse title='Nota Fiscal' onClick={() => handleClickFiscalDocuments(delivery.invoice_id.toString())} arrow>
      {loadingDocuments && <Spin />}

      {!loadingDocuments &&
        Array.isArray(fiscalDocuments) &&
        fiscalDocuments.length > 0 &&
        fiscalDocuments.map((document: IFiscalDocuments, index) => {
          return (
            <div key={'document-' + index} className={classes.fiscalDocument}>
              <a href={document.url} target='_blank' rel='noopener noreferrer'>
                <Icon>insert_drive_file</Icon>{' '}
                <span>
                  {document.title} ({document.ext.toUpperCase()})
                </span>
              </a>
            </div>
          );
        })}

      {!loadingDocuments && (!Array.isArray(fiscalDocuments) || fiscalDocuments.length === 0) && (
        <div className={classes.notfound}>Nenhum arquivo encontrado...</div>
      )}
    </MyCollapse>
  );
};

export default FiscalDocument;
